import {AXIOS} from '../constants/axios';

export default{
  getCountriesIso3166: getCountriesIso3166,
  getStatesByAlpha2: getStatesByAlpha2,
  getCountryCodes: getCountryCodes,
  getConektaPublicKey: getConektaPublicKey,
  getFiscalAddress: getFiscalAddress,
  getBusinessName: getBusinessName,
  getHomieConfig: getHomieConfig,
  getHomieConfigByKey: getHomieConfigByKey,
  getMaxAssetSize: getMaxAssetSize,
  getMaxPictureSize: getMaxPictureSize,
  getTestimonials: getTestimonials,
  getAgencyCustomizations: getAgencyCustomizations,
  getPartnerLogo: getPartnerLogo,
  getAdvisorRentsFees: getAdvisorRentsFees
}

function getCountriesIso3166(){
  return AXIOS.get('/utilities/countries_iso3166.json');
}

function getStatesByAlpha2(alpha2){
  return AXIOS.get('/utilities/render_states_by_country', {params: {country_id: alpha2}});
}

function getCountryCodes(){
  return AXIOS.get('/utilities/country_codes.json');
}

function getConektaPublicKey(){
  return AXIOS.get(`/utilities/conekta_public_key.json`);
}

function getFiscalAddress(){
  return AXIOS.get(`/utilities/fiscal_address.json`);
}

function getBusinessName(){
  return AXIOS.get(`/utilities/business_name.json`);
}

function getHomieConfig() {
  return AXIOS.get('/utilities/homie_config.json');
}

function getHomieConfigByKey(key) {
  return AXIOS.get(`api/internal/homie_configs/${key}`);
}

function getMaxAssetSize(){
  return AXIOS.get(`/utilities/max_asset_size.json`);
}

function getMaxPictureSize(){
  return AXIOS.get(`/utilities/max_picture_size.json`);
}

function getTestimonials(kind){
  return AXIOS.get(`/utilities/testimonials/${kind}`);
}

function getAgencyCustomizations(){
  return AXIOS.get(`/utilities/agencies-customizations.json`);
}

function getPartnerLogo(name, fullLogo){
  return AXIOS.get(`/utilities/get-partner-logo/${name}?full=${fullLogo}`)
}

function getAdvisorRentsFees(){
  return AXIOS.get(`/utilities/rents_fees_for_advisor.json`);
}